var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicenseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11127_59755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.78 8.00781H2.2605C1.48668 8.00781 0.859375 8.63512 0.859375 9.40894V18.9017C0.859375 19.6755 1.48668 20.3028 2.2605 20.3028H13.78C14.5538 20.3028 15.1811 19.6755 15.1811 18.9017V9.40894C15.1811 8.63512 14.5538 8.00781 13.78 8.00781Z",
    stroke: "#C2C2C2",
    strokeWidth: 1.72569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2882 8.01167V6.11285C13.2882 3.21579 10.9396 0.867188 8.04254 0.867188C5.14548 0.867188 2.79688 3.21579 2.79688 6.11285V8.01167",
    stroke: "#C2C2C2",
    strokeWidth: 1.72569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56336 13.7034C8.86123 13.4055 8.86123 12.9226 8.56336 12.6247C8.26549 12.3268 7.78254 12.3268 7.48466 12.6247C7.18679 12.9226 7.18679 13.4055 7.48466 13.7034C7.78254 14.0013 8.26549 14.0013 8.56336 13.7034Z",
    stroke: "#C2C2C2",
    strokeWidth: 1.72569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02344 15.9098V13.1641",
    stroke: "#C2C2C2",
    strokeWidth: 1.72569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11127_59755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0473,
    height: 21.1652,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseIcon);
export default __webpack_public_path__ + "static/media/LicenseIcon.ddce5dea.svg";
export { ForwardRef as ReactComponent };